import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

/**
 * This custom Route Reuse Strategy is identical to Angulars default except for an addition in the shouldReuseRoute method.
 * @see https://github.com/angular/angular/blob/main/packages/router/src/route_reuse_strategy.ts
 */
Injectable({ providedIn: 'root' });
export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void {}

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  /**
   * The if block added here allows us to reload the current route.
   * See RouteReloadService for more details.
   */
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (curr.data.reloadCurrentRoute) {
      return false;
    }
    return future.routeConfig === curr.routeConfig;
  }
}
